{
  "move_node": {
    "title": "Wählen Sie einen neuen Standort für den {{ nodeType }}",
    "multi_title": "Wählen Sie einen neuen Standort für die {{ count }} ausgewählten Artikel",
    "empty_title": "Wähle einen neuen Standort",
    "success": "Die Artikel wurden erfolgreich verschoben.",
    "multiple_items": "Mehrere Artikel",
    "no_permission_tooltip": "Sie sind nicht berechtigt, Artikel an diesen Ort zu verschieben"
  },
  "permissions": {
    "request_access": "Zugriff anfordern",
    "no_read_permissions": "Sie haben keine Leseberechtigungen für diesen Artikel",
    "no_write_permissions": "Sie haben keine Schreibberechtigungen für diesen Artikel"
  },
  "mappingLibraries": {
    "My Workspace": "Mein Workspace",
    "My workspace": "Mein Workspace",
    "Team Workspace": "Team-Arbeitsbereich",
    "Team workspace": "Team-Arbeitsbereich",
    "Shared library": "Team-Arbeitsbereich",
    "Recently viewed": "Kürzlich angesehen",
    "Recently Viewed": "Kürzlich angesehen",
    "Favourites": "Favoriten",
    "add_to_favourites": "zu den Favoriten hinzufügen",
    "remove_from_favourites": "aus den Favoriten entfernen"
  },
  "copy_node": {
    "button": "Kopieren Sie {{ nodeType }}",
    "title": "Wählen Sie einen Speicherort, um den {{ nodeType }} zu kopieren",
    "multi_title": "Wählen Sie einen Ort, an dem die ausgewählten Elemente kopiert werden sollen",
    "empty_title": "Wählen Sie einen Standort",
    "success": "Die Artikel wurden erfolgreich kopiert.",
    "multiple_items": "Mehrere Artikel",
    "no_permission_tooltip": "Sie sind nicht berechtigt, Elemente an diesen Speicherort zu kopieren",
    "copy_with_map_objects": "Kartenobjekte kopieren",
    "options_title": "Optionen kopieren",
    "options_submit_button": "Kopieren",
    "options_description": {
      "map_objects_only": "Wählen Sie aus, ob beim Kopieren Kartenobjekte einbezogen werden sollen.",
      "map_objects_and_permissions": "Wählen Sie aus, ob Kartenobjekte und Berechtigungen beim Kopieren berücksichtigt werden sollen."
    }
  },
  "delete_node": {
    "selected_items_cannot_be_deleted": "Sie können das/die ausgewählte (n) Element (e) nicht löschen"
  },
  "create_node": {
    "change_location": "Standort ändern"
  }
}